import { ReactElement } from 'react';
import { IconBaseProps } from 'react-icons/lib';
import { MdRateReview } from 'react-icons/md';
import { ApplicationConfig } from '../../config/config';

const FeedbackLink = (props: IconBaseProps): ReactElement => {
  const href = `mailto:${ApplicationConfig.support.email}?subject=Beacon Feedback`;
  return (
    <a href={href}>
      <MdRateReview {...props}></MdRateReview>
    </a>
  );
};

export { FeedbackLink };
